import { render, staticRenderFns } from "./ProyeccionHidrocarburosExport.vue?vue&type=template&id=220645c8"
import script from "./ProyeccionHidrocarburosExport.vue?vue&type=script&lang=js"
export * from "./ProyeccionHidrocarburosExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports